module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./index.js"));
	}, "ShareReconstituTransitView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ShareReconstituTransitView!./src/pages/Shop/Draw/ShareReconstituTransit/index.js
// module id = 893
// module chunks = 438